const mySummary = {
  path: 'mySummary',
  component: resolve => require(['../../../../pages/user/course/mysummary'], resolve)
}

export default mySummary



// WEBPACK FOOTER //
// ./src/router/user/course/mysummary/index.js